@if (loading()) {
  <div class="overlay">
    <kendo-loader
      type="infinite-spinner"
      themeColor="primary"
      size="large">
    </kendo-loader>

    <div style="margin-top:12px; font-weight:500;">
      {{ loadingMessage() }}
    </div>
  </div>
}
<div [style.margin-top.px]="20" class="center-center">
  <div class="component-container-column">
    <kendo-card orientation="vertical" [width]="'450px'">
      <kendo-card-header class="k-hbox card-header-colored">
        <h1 kendoCardTitle i18n>Login</h1>
      </kendo-card-header>
      <kendo-card-body>
        <div class="margin-left-15 margin-right-15">
          <form class="k-form" [formGroup]="loginForm">
            <kendo-formfield>
              <kendo-label [for]="email" text="Email" i18n-text></kendo-label>
              <kendo-textbox formControlName="email" [clearButton]="true" #email required></kendo-textbox>
              @if (loginForm.get('email')?.hasError('required')) {
                <kendo-formerror>Error: Email is required
                </kendo-formerror>
              }
              @if (loginForm.get('email')?.hasError('email')) {
                <kendo-formerror>Error: Invalid Email</kendo-formerror>
              }
            </kendo-formfield>
            <kendo-formfield class="margin-top-10">
              <kendo-label [for]="password" text="Password" i18n-text></kendo-label>
              <kendo-textbox formControlName="password" #password required [clearButton]="true">
                <ng-template kendoTextBoxSuffixTemplate>
                  <i class="far fa-eye"></i>
                  <button kendoButton look="clear" icon="eye" type="button"
                    [ngClass]="visible === 'text' ? 'visible': 'not-visible'"
                  (click)="toggleVisibility()"></button>
                </ng-template>
              </kendo-textbox>
              @if (loginForm.get('password')?.hasError('required')) {
                <kendo-formerror i18n>Error: Password is required
                            </kendo-formerror>
              }
            </kendo-formfield>
            <div [style.margin-top.px]="15">
              <button kendoButton class="k-button full-width" type="submit" [primary]="true" themeColor="primary"
                [disabled]="!loginForm.valid" (click)="login()">Login
              </button>
            </div>
          </form>
          <a [style.margin-top.px]="10" class="center-center"
          routerLink="/forgotPassword" i18n="forgot_password_link|Forgot Password?"> Forgot Password?</a>
        </div>
      </kendo-card-body>
    </kendo-card>
  </div>
</div>
